import React from 'react';
import { TabsComponent } from '../../../Components';
import { ClientTrackingTabsData } from './ClientTrackingTabsData';

const ClientTrackingTabs = () => {
  const [currentTab, setCurrentTab] = React.useState(0);
  const onTabChanged = (_e, newTap) => setCurrentTab(newTap);
  return (
    <TabsComponent
      data={ClientTrackingTabsData}
      currentTab={currentTab}
      onTabChanged={onTabChanged}
      componentInput={'component'}
      labelInput={'label'}
      withDynamicComponents
      themeClasses={'theme-solid'}
    />
  );
};
export default ClientTrackingTabs;
